import { Routes } from 'common/routeConfig'
import StaticPageWrapper from 'components/staticPage/StaticPageWrapper'
import { useDataContext } from 'context/DataContext'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useParseHTML } from 'utils/hooks/use-parse-html'

type StaticPageProps = {
    page: keyof typeof StaticPages
    withTitle?: boolean
}

enum StaticPages {
    'disclaimer' = 'disclaimer'
}

const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
]

const formatDatabaseDate = (databaseDate?: string) => {
    if (!databaseDate) {
        return ''
    }

    const datePart = databaseDate.split(' ')[0]
    const [year, month, day] = datePart.split('-')

    const monthIndex = Number(month) - 1
    const dayNumber = Number(day)

    if (!year || monthIndex < 0 || monthIndex > 11 || !dayNumber) {
        return databaseDate
    }

    return `${monthNames[monthIndex]} ${dayNumber} ${year}`
}

const StaticPage: React.FC<StaticPageProps> = ({ page, withTitle }) => {
    const [htmlContent, setHtmlContent] = useState<string | null>(null)
    const navigate = useNavigate()
    const { metaInfo } = useDataContext()
    const formattedDatabaseDate = formatDatabaseDate(metaInfo?.databaseDate)

    useEffect(() => {
        async function fetchHtmlContent() {
            try {
                const response = await fetch(
                    `./assets/static/${StaticPages[page]}.html`
                )

                if (!response.ok) {
                    navigate(Routes.NOT_FOUND)
                    return
                }

                let html = await response.text()

                if (page === 'disclaimer') {
                    html = html.replace(
                        '{{databaseDate}}',
                        formattedDatabaseDate || 'N/A'
                    )
                }

                setHtmlContent(html)
            } catch (error) {
                navigate(Routes.NOT_FOUND)
                console.error('Error fetching HTML content:', error)
            }
        }

        fetchHtmlContent()
    }, [navigate, page, formattedDatabaseDate])

    const parsedHTML = useParseHTML(htmlContent)
    const { t } = useTranslation('pages')

    return (
        <StaticPageWrapper
            isContentPage
            title={withTitle ? t(`${page}.title`) : undefined}
        >
            {parsedHTML}
        </StaticPageWrapper>
    )
}

export default StaticPage